import { userSharedSelectors } from 'common/modules/ReactShared';
import { useTypedSelector } from 'students/stores/_utils';

function useSupportEqualsTarget(): boolean {
  const isEqual = useTypedSelector(
    userSharedSelectors.selectIfSupportEqualsTargetLanguage
  );

  return isEqual;
}

export default useSupportEqualsTarget;
